export default __webpack_public_path__ + "static/media/python.0e3d57bf.png";